import { h, Component } from 'preact';
import { getApiUrl, post, setTokenInLocalCookies } from 'utils/api';
import { joinClasses, triggerAnim } from 'utils/utils';
import { trackGAEvent } from 'utils/track';

import s from 'components/login/login.scss';

export default class Login extends Component {
	constructor(props) {
		super(props);
		this.onSubmit = this.onSubmit.bind(this);
	}

	async onSubmit(e) {
		e.preventDefault();
		if (this.state.submitting) {
			return;
		}
		const data = Object.fromEntries(new FormData(e.target));
		if (!data.username || !data.password) {
			this.setState({ error: 'Please input a username and a password' });
			return;
		}
		this.setState({ submitting: true });
		try {
			const { token } = await post('auth/login', Object.fromEntries(new FormData(e.target)));
			setTokenInLocalCookies(token);
			await this.props.onLogIn?.();
			this.setState({ submitting: false });
			trackGAEvent('landing-login-success', 'login', data.username);
		} catch (err) {
			// TOOD: handle different errors
			this.setState({ error: 'Unable to log in', submitting: false });
			triggerAnim(e.target, s.error);
			trackGAEvent('landing-login-fail', 'login', data.username);
		}
	}

	render(props, state) {
		return (
			<form
				class={joinClasses(s.form, state.submitting && s.submitting, state.error && s.error)}
				action={getApiUrl('auth/login')}
				method="POST"
				onSubmit={this.onSubmit}
			>
				<h2 class={s.title}>Welcome to Prime&nbsp;Premiere <span class={s.highlight}>Check-In</span></h2>
				<label class={s.field}>
					<span class={s.name}>Username</span>
					<input type="text" name="username" required />
				</label>
				<label class={s.field}>
					<span class={s.name}>Password</span>
					<input type="password" name="password" required />
				</label>
				<button class={s.submit} type="submit"><span /></button>
				{/* state.error && <div class={s.errorMessage}>{state.error}</div> */}
			</form>
		);
	}
}